<template>

  <div class="statistics-section">
    <TopBar>
      <template v-slot:left>
      </template>
      <template v-slot:right>
        <MonthSelector />
      </template>
    </TopBar>

    <div class="statistics-grid">

      <div class="stats-card" v-for="(card, index) in statsForTrips" :key="'stats-card-' + index">
        <div class="stats-card-header">
          <i class="fa stats-icon" :class="card.icon"></i>
          <span class="card-title stats-title stats-title-green">{{ card.title }}</span>
        </div>
        <table class="stats-table">
          <tbody>
            <tr v-for="(item, idx) in card.extra" :key="idx">
              <td class="stats-label">
                <span v-html="item.name"></span>
              </td>
              <td class="stats-value">{{ item.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

  
</template>
<script>
import Api from '@/services/ApiGateway'
import Ports from '@/repositories/ports';


import TopBar from '../components/shared/TopBar.vue';
import MonthSelector from '@/components/shared/MonthSelector.vue'
import { mapGetters } from 'vuex';


const getTopSellingPorts = (topSellingPorts) => {
  return topSellingPorts.map(port => ({
    name: Ports.locationName(port.ArrStation),
    value: port.tripsCount
  }));
}


const getTopSellingTrips = (topSellingTrips) => {
  return topSellingTrips.map(trip => ({
    name: Ports.locationName(trip.DepStation) + ' <i class="fa fa-angle-right"></i> ' + Ports.locationName(trip.ArrStation),
    value: trip.tripsCount
  }))
}

export default {
  components: {
    TopBar,
    MonthSelector
  },
  data() {
    return {
      isWaitingForTopSellingData: true,
      topSellingPorts: [],
      topSellingTrips: []
    }
  },
  watch: {
    // Executes instantly once component comes into view, and each time the date changes
    getActiveDates(previous, current) {
      this.getTopSellingData();
    }
  },
  computed: {
    ...mapGetters({
      getActiveDates: 'datesModule/getActiveDates',
      impersonateUser: 'authentication/impersonateUser',
    }),
    statsForTrips() {
      return [
        {
          type: 'warning',
          icon: 'fa fa-trophy',
          title: 'Top selling destinations',
          value: '',
          extra: this.topSellingPorts
        },
        {
          type: 'warning',
          icon: 'fa fa-star',
          title: 'Top selling trips',
          value: '',
          extra: this.topSellingTrips
        },
      ]
    },
  },
  methods: {
    getTopSellingData() {
      this.isWaitingForTopSellingData = false;
      Api.getTopSellingData(this.impersonateUser).then(result => {
        const { topSellingPorts, topSellingTrips } = result.data;
        this.topSellingPorts = getTopSellingPorts(topSellingPorts);
        this.topSellingTrips = getTopSellingTrips(topSellingTrips);
        this.isWaitingForTopSellingData = false;
      })
    }
  }
}
</script>


<style scoped>
.statistics-section {
  padding: 1rem 0 2rem 0;
}

.statistics-toolbar {
  margin-bottom: 2rem;
}

.statistics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.stats-card {
  background: var(--white);
  border-radius: 10px;
  box-shadow: 0 2px 8px var(--gray-light);
  padding: 1.8rem 2rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
}

.stats-card-header {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 1.2rem;
}

.stats-icon {
  font-size: 2rem;
  color: var(--gray-light);
}

.stats-title-green {
  color: var(--brand-primary);
}

.stats-table {
  width: 100%;
  border-collapse: collapse;
}

.stats-label {
  color: var(--gray-darker);
  font-size: 1.05rem;
  padding: 0.5rem 0.2rem;
  border-bottom: 1px solid var(--gray-lightest, #f8f9fb);
}

.stats-value {
  color: var(--gray);
  font-size: 1.05rem;
  text-align: right;
  padding: 0.5rem 0.2rem;
  border-bottom: 1px solid var(--gray-lightest, #f8f9fb);
  min-width: 60px;
}

.stats-table tr:last-child .stats-label,
.stats-table tr:last-child .stats-value {
  border-bottom: none;
}

@media (max-width: 900px) {
  .statistics-grid {
    grid-template-columns: 1fr;
  }
}
</style>
